import BasicPage from "@components/basicPage";
import { getClient } from "@lib/sanity";
import { SanityBasicPage, SanityBPFetcher } from "groq/basicPage";
import { GetServerSideProps } from "next";
import { i18n } from "next-i18next.config";

export interface BasicPageProps {
  page: SanityBasicPage;
}

function BasicPageView(props: BasicPageProps) {
  return <BasicPage {...props} />;
}

export default BasicPageView;

export const getServerSideProps: GetServerSideProps<BasicPageProps> = async ({
  locale = i18n.defaultLocale,
  preview = false,
  params,
}) => {
  const slug = params?.slug;

  const client = getClient(preview);

  const fetcher = new SanityBPFetcher({ client, locale, isPreview: !!preview });

  const basicPage = await fetcher.fetchBasicPage(slug as string);

  if (!basicPage) {
    return {
      redirect: {
        destination: "/404",
        permanent: false,
      },
    };
  }

  return {
    props: {
      page: basicPage,
    },
  };
};
